import toast from "react-hot-toast"; // Import react-hot-toast
import axios from "axios";

// export const fetchGuestHouseStats = async () => {
//   try {
//     const response = await fetch(
//       "${process.env.REACT_APP_BASE_URL}/Booking/GuestHouseBookingStats?outletID=3"
//     );
//     const result = await response.json();

//     if (response.ok && result.status === 200) {
//       return result.data[0]; // Return the stats object
//     } else {
//       toast.error("Failed to fetch stats:", result.message);
//       return null;
//     }
//   } catch (error) {
//     toast.error("Error fetching data:", error);
//     return null;
//   }
// };

export const fetchGuestHouseOutlets = async () => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_BASE_URL}/Auth/GuestHouseOutlets`,
    );
    const result = await response.json();

    if (response.ok && result.status === 1) {
      return result.data; // Return array of outlets
    } else {
      toast.error("Failed to fetch outlets:", result.message);
      return [];
    }
  } catch (error) {
    toast.error("Error fetching outlets:", error);
    return [];
  }
};

export const checkRoomAvailability = async (startDate, endDate, outletId) => {
  try {
    const url = `${process.env.REACT_APP_BASE_URL}/Booking/GeuestHouseRoomAvailability?outletID=${outletId}&startDate=${startDate}&endDate=${endDate}`;

    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      try {
        const errorResult = await response.json();
        toast.error(
          errorResult.message || `Request failed: ${response.statusText}`,
        );
      } catch (parseError) {
        // If JSON parsing fails, fall back to statusText
        toast.error(`Request failed: ${response.statusText}`);
      }
      return null;
    }
    const result = await response.json();

    if (result.status === 200) {
      toast.success(result.message);
      return result.data;
    } else {
      toast.error(`Failed to check availability: ${result.message}`);
      return null;
    }
  } catch (error) {
    toast.error("Error checking room availability.");
    console.error("Fetch Error:", error); // Uncomment this for debugging
    return null;
  }
};

//check venue availability
// {
//   "checkDate": "2025-10-01T12:55:20.199Z",
//   "venueID": 0,
//   "venueTypeID": 0,
//   "outletID": 0
// }
export const checkVenueAvailability = async (
  checkDate,
  venueID, //parentId
  venueTypeID, //typeId
  outletID,
) => {
  try {
    const requestBody = {
      checkDate,
      venueID,
      venueTypeID,
      outletID,
    };

    console.log("Venue availability request:", requestBody); // Debug log

    const response = await fetch(
      `${process.env.REACT_APP_BASE_URL}/Booking/check_venue_availability`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      },
    );

    const result = await response.json();

    // Response body
    // Download
    // {
    //   "venues": [
    //     {
    //       "serviceId": 218,
    //       "serviceName": "VENUE ",
    //       "serviceTypeId": 468,
    //       "serviceTypeName": "DINNING HALL & POOL",
    //       "outletId": 3,
    //       "isBooked": true,
    //       "isAvailable": false
    //     }
    //   ],
    //   "availableVenuesCount": 0
    // }

    if (response.ok) {
      console.log("API Response:", result); // Debug log

      // Handle different response structures
      const venues = result.data?.venues || result.venues || [];

      if (!Array.isArray(venues) || venues.length === 0) {
        toast.error("No venues found for the selected criteria.");
        return null;
      }

      // Process the available venues
      const availableVenues = venues.filter((venue) => venue.isAvailable);

      if (availableVenues.length === 0) {
        toast.error("The selected venue is not available on the chosen date.");
        return null;
      }

      toast.success("Venue is available.");
      return result.data || result;
    } else {
      toast.error(`Failed to check venue availability: ${result.message}`);
      return null;
    }
  } catch (error) {
    console.error("Venue availability API error:", error);
    console.error("Error details:", {
      message: error.message,
      stack: error.stack,
    });
    toast.error("Error checking venue availability.");
    return null;
  }
};

export const getProductOrServiceDetails = async (
  keyname,
  outletID,
  companyID = null,
) => {
  try {
    // Build query parameters
    const params = new URLSearchParams();
    params.append("keyname", keyname);
    params.append("outletID", outletID);

    // Only add companyID if it exists (for existing company customers)
    if (companyID) {
      params.append("companyID", companyID);
    }

    const response = await fetch(
      `${process.env.REACT_APP_BASE_URL}/Service/GetProductOrServiceDetails?${params.toString()}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      },
    );

    const result = await response.json();

    if (response.ok && result.status === 200) {
      return result.data; // Returns product/service details with pricing
    } else {
      toast.error("Failed to fetch product details:", result.message);
      return null;
    }
  } catch (error) {
    toast.error("Error fetching product details:", error.message);
    return null;
  }
};

export const fetchRoomTypes = async (
  outletID,
  companyID = null,
  customerID = null,
) => {
  try {
    // Build URL with optional companyID (backend filters by company if provided)
    let url = `${process.env.REACT_APP_BASE_URL}/Service/GetProductOrServiceDetails?keyname=Accommodation&outletID=${outletID}`;
    if (companyID) url += `&companyID=${companyID}`;
    // If in future backend supports customerID specific filtering, append as well
    if (!companyID && customerID) url += `&customerID=${customerID}`;

    const response = await axios.get(url);
    if (response.data.status === 200) {
      return response.data.data.flatMap((item) =>
        item.childRecords.map((child) => ({
          typeName: child.typeName.trim(),
          rate: child.rate,
          parentId: item.parentId,
          childId: child.childId,
          typeId: child.typeId,
        })),
      );
    }
    return [];
  } catch (error) {
    console.error("Error fetching room types:", error);
    return [];
  }
};

export const fetchServiceData = async () => {
  const response = await fetch(
    `${process.env.REACT_APP_BASE_URL}/Service/GetAddOnDetails?outletID=3`,
  );
  const data = await response.json();

  return data.data.map((service) => ({
    id: service.productServiceName.toLowerCase(),
    name: service.productServiceName,
    itemCount: service.childRecords.length,
    items: service.childRecords.map((child) => ({
      id: child.typeName.toLowerCase().replace(/\s+/g, "-"),
      name: child.typeName,
      rate: child.rate,
      parentId: service.parentId,
      childId: child.childId,
      typeId: child.typeId,
    })),
  }));
};

export const createReservation = async (reservationData) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_BASE_URL}/Booking/CreateReservation`,
      {
        method: "POST", // Use POST method
        headers: {
          "Content-Type": "application/json", // Set the content type to JSON
        },
        body: JSON.stringify(reservationData), // Send the reservation data as JSON in the body
      },
    );

    const result = await response.json(); // Parse the JSON response

    if (response.ok && result.status === 200) {
      // If the response is successful, return the result
      return result.data; // You can adjust this based on the actual response format
    } else {
      // Handle error responses
      toast.error("Failed to create reservation:", result.message);
      return null;
    }
  } catch (error) {
    // Handle fetch errors
    toast.error("Error creating reservation:", error.message);
    return null;
  }
};

const API_URL = `${process.env.REACT_APP_BASE_URL}/Booking/CustomerEmailQuery`;

export const sendContactQuery = async ({
  customerName,
  customerEmail,
  emailBody,
}) => {
  try {
    const response = await axios.post(
      API_URL,
      {
        customerName,
        customerEmail,
        emailBody,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );

    return response.data; // You can return the full response if needed
  } catch (error) {
    throw error;
  }
};

export const createCompany = async (companyData) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_BASE_URL}/Customer/CreateCompany`,
      {
        method: "POST", // Use POST method
        headers: {
          "Content-Type": "application/json", // Set the content type to JSON
        },
        body: JSON.stringify(companyData), // Send the reservation data as JSON in the body
      },
    );

    const result = await response.json(); // Parse the JSON response

    if (response.ok && result.status === 200) {
      // If the response is successful, return the result
      return result.data; // You can adjust this based on the actual response format
    } else {
      // Handle error responses
      toast.error("Failed to create company:", result.message);
      return null;
    }
  } catch (error) {
    // Handle fetch errors
    toast.error("Error creating company:", error.message);
    return null;
  }
};
export const getCompany = async (searchParams) => {
  try {
    const { companyName, companyID, outletID } = searchParams;

    // Build query parameters
    const params = new URLSearchParams();
    if (companyName) params.append("CompanyName", companyName);
    if (companyID) params.append("CompanyID", companyID);
    if (outletID) params.append("outletID", outletID);

    const response = await fetch(
      `${process.env.REACT_APP_BASE_URL}/Customer/GetCompany?${params.toString()}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      },
    );

    const result = await response.json();

    if (response.ok && result.status === 200) {
      return result.data; // Returns array of companies
    } else {
      toast.error("Failed to fetch company data:", result.message);
      return null;
    }
  } catch (error) {
    toast.error("Error fetching company data:", error.message);
    return null;
  }
};

export const getCustomersInt = async (searchParams) => {
  try {
    const { keyword, customerID, outletID } = searchParams;

    // Build query parameters
    const params = new URLSearchParams();
    if (keyword) params.append("keyword", keyword);
    if (customerID) params.append("customerID", customerID);
    if (outletID) params.append("outletID", outletID);

    const response = await fetch(
      `${process.env.REACT_APP_BASE_URL}/Customer/GetCustomersInt?${params.toString()}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      },
    );

    const result = await response.json();

    if (response.ok && result.status === 200) {
      return result.data; // Returns array of customers
    } else {
      toast.error("Failed to fetch customer data:", result.message);
      return null;
    }
  } catch (error) {
    toast.error("Error fetching customer data:", error.message);
    return null;
  }
};

export const createOTP = async (otpData) => {
  try {
    // Create the request body - only include the ID that has a value
    let requestBody = {};

    if (otpData.customerID && otpData.customerID !== 0) {
      // Only for individual customers
      requestBody.customerID = otpData.customerID;
    }

    if (otpData.companyID && otpData.companyID !== 0) {
      // Only for companies
      requestBody.companyID = otpData.companyID;
    }

    console.log("OTP Request Body:", requestBody); // Debug log

    const response = await fetch(
      `${process.env.REACT_APP_BASE_URL}/Booking/CreateOTP`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      },
    );

    const result = await response.json();

    if (response.ok && result.status === 200) {
      // toast.success("OTP sent successfully!");
      return result.data;
    } else {
      toast.error("Failed to send OTP:", result.message);
      return null;
    }
  } catch (error) {
    toast.error("Error sending OTP:", error.message);
    return null;
  }
};

// Validate OTP - Verify the OTP and get customer/company ID
export const validateOTP = async (otp) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_BASE_URL}/Booking/ValidateOTP`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ otp }),
      },
    );

    const result = await response.json();

    //     {
    //     "status": 200,
    //     "message": "OTP validated successfully.",
    //     "data": {
    //         "isValid": true,
    //         "customers": {
    //             "customerID": 1120,
    //             "salutation": "",
    //             "customerName": "Dorah sekele",
    //             "dateOfBirth": "",
    //             "email": "dorah@gmail.com",
    //             "countryCode": "27",
    //             "customerRating": -1,
    //             "taxNumber": "",
    //             "locality": "",
    //             "pin": "",
    //             "phoneNumber": "727238769",
    //             "address": "not far",
    //             "orderAmount": 8600.00,
    //             "isActive": 1,
    //             "hasOrder": 1,
    //             "payment_types": "Cash, Card, Bank Transfer, Account Payment",
    //             "accPayDate": "9/9/2025 12:41:00 PM",
    //             "payment_Terms": "Net 14",
    //             "limit": 1000.00,
    //             "creditAccStatus": "",
    //             "currentLimit": 1000.00
    //         },
    //         "customerID": 1120,
    //         "companyID": null
    //     }
    // }

    if (response.ok && result.status === 200 && result.data.isValid) {
      toast.success("OTP validated successfully!");
      return {
        isValid: result.data.isValid,
        customerID: result.data.customerID,
        companyID: result.data.companyID,
        customerDetails: result.data.customers,
        companydetails: result.data.company,
        otp: result.data.otp,
      };
    } else {
      toast.error(
        "Invalid OTP:",
        result.message || "The OTP may be incorrect, already used, or expired.",
      );
      return {
        isValid: false,
        customerID: null,
        companyID: null,
        otp: otp,
      };
    }
  } catch (error) {
    toast.error("Error validating OTP:", error.message);
    return {
      isValid: false,
      customerID: null,
      companyID: null,
      otp: otp,
    };
  }
};

export const deleteSpecificRoom = async (KeyID, subCustomerID, orderID) => {
  try {
    // Basic validation
    if (KeyID == null || subCustomerID == null || orderID == null) {
      console.error("deleteSpecificRoom: missing one or more required IDs", {
        KeyID,
        subCustomerID,
        orderID,
      });
      return {
        status: 400,
        success: false,
        error: "Missing required identifiers",
      };
    }

    const k = Number(KeyID);
    const c = Number(subCustomerID);
    const o = Number(orderID);

    console.log("Calling deleteSpecificRoom API (query params) with:", {
      keyID: k,
      customerID: c,
      orderID: o,
    });

    // Per Swagger example: parameters in query string, empty body
    const url = `${process.env.REACT_APP_BASE_URL}/Booking/RemoveCustomerRoom?keyID=${k}&customerID=${c}&orderID=${o}`;

    const response = await axios.post(url, "");

    console.log("Raw API response:", response);

    return {
      status: response.status,
      data: response.data,
      success: response.status >= 200 && response.status < 300,
    };
  } catch (error) {
    console.error("Error deleting room:", error);
    console.error("Error response:", error.response?.data);

    return {
      status: error.response?.status || 500,
      data: error.response?.data || null,
      success: false,
      error: error.message,
    };
  }
};
export const resendBookingEmail = async ({
  outletId,
  orderId,
  documentType,
}) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_BASE_URL}/Booking/resend-booking-email`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          outletId: Number(outletId) || 0,
          orderId: Number(orderId) || 0,
          documentType: documentType || "Proforma",
          BookingType: documentType || "Proforma",
        }),
      },
    );

    const result = await response.json().catch(() => null);

    if (!response.ok) {
      const message = result?.message || response.statusText || "Resend failed";
      toast.error(message);
      return { success: false, status: response.status, message };
    }

    return {
      success: true,
      status: response.status,
      data: result?.data ?? result,
      message: result?.message || "Resend request sent successfully",
    };
  } catch (error) {
    console.error("resendBookingEmail error:", error);
    toast.error("Error sending resend request.");
    return {
      success: false,
      status: 500,
      message: error.message || "Error sending resend request",
    };
  }
};

export const updateReservation = async (payload) => {
  try {
    console.log("=== UPDATE RESERVATION API CALL ===");
    console.log("Payload being sent:", payload);
    console.log("Payload size:", JSON.stringify(payload).length, "characters");

    const response = await fetch(
      `${process.env.REACT_APP_BASE_URL}/Booking/UpdateReservations`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      },
    );

    console.log("Response status:", response.status);
    console.log(
      "Response headers:",
      Object.fromEntries(response.headers.entries()),
    );

    const result = await response.json();
    console.log("Response body:", result);

    return { status: response.status, ...result };
  } catch (e) {
    console.error("updateReservation API error:", e);
    console.error("Error details:", {
      name: e.name,
      message: e.message,
      stack: e.stack,
    });
    return {
      status: 500,
      message: `API Error: ${e.message}`,
      error: true,
    };
  }
};

export const createCreditAccount = async (payload) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_BASE_URL}/Credit/credit-account`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      },
    );

    const result = await response.json();
    return { status: response.status, ...result };
  } catch (e) {
    console.error("createCreditAccount error", e);
    return { status: 500, message: e.message };
  }
};

export const getClientsByPaymentType = async (paymentTypeID, outletID) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_BASE_URL}/Credit/by-payment-type/${paymentTypeID}?outletID=${outletID}`,
      {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      },
    );

    const result = await response.json();
    return { status: response.status, data: result };
  } catch (e) {
    console.error("getClientsByPaymentType error", e);
    return { status: 500, message: e.message };
  }
};

// Fetch client outstanding and aging details
export const getClientOutstanding = async () => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_BASE_URL}/Credit/client-outstanding`,
      {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      },
    );

    const result = await response.json();
    // Expecting shape: { agingSummaries: [...], orderDetails: [...] }
    return { status: response.status, data: result };
  } catch (e) {
    console.error("getClientOutstanding error", e);
    return { status: 500, message: e.message };
  }
};

// Get a unified list of all clients (individuals and companies)
// Accepts optional query params: keyword, keyID, outletID, companyID, companyName
export const getAllClients = async (searchParams = {}) => {
  try {
    const { keyword, keyID, outletID, companyID, companyName } = searchParams;

    const params = new URLSearchParams();
    if (keyword) params.append("keyword", keyword);
    if (keyID) params.append("keyID", keyID);
    // Always scope to outletID=3 as requested
    params.append("outletID", 3);
    if (companyID) params.append("companyID", companyID);
    if (companyName) params.append("companyName", companyName);

    const base = `${process.env.REACT_APP_BASE_URL}/Customer/getAlistOfClients`;
    const url = params.toString() ? `${base}?${params.toString()}` : base;

    const response = await fetch(url, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });

    const result = await response.json();

    if (!response.ok) {
      toast.error(
        "Failed to fetch clients:",
        result.message || response.statusText,
      );
      return [];
    }

    // Accept multiple backend shapes
    if (Array.isArray(result)) return result;
    if (Array.isArray(result?.data)) return result.data;
    if (result?.status === 200 || result?.status === 1)
      return result?.data || [];
    // Fallback: if result looks like a dictionary of clients
    if (result && typeof result === "object") {
      const maybeArray = result.items || result.list || result.records;
      if (Array.isArray(maybeArray)) return maybeArray;
    }
    return [];
  } catch (error) {
    toast.error("Error fetching clients:", error.message);
    return [];
  }
};

// Update credit account status (On hold / Active)
export const updateCreditAccStatus = async ({
  clientId,
  newStatus,
  exceed_Limit,
}) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_BASE_URL}/Credit/updateCreditAccStatus`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ clientId, newStatus, exceed_Limit }),
      },
    );

    const result = await response.json();
    // Many of our APIs return a body with status/message; also expose HTTP status
    return { status: response.status, ...result };
  } catch (e) {
    console.error("updateCreditAccStatus error", e);
    return { status: 500, message: e.message };
  }
};

export const fetchDailyOccupancy = async ({
  singleDate,
  startDate,
  endDate,
}) => {
  try {
    const params = new URLSearchParams({ outletID: "3" });

    if (singleDate) params.append("singleDate", singleDate);
    if (startDate) params.append("startDate", startDate);
    if (endDate) params.append("endDate", endDate);

    const response = await fetch(
      `${process.env.REACT_APP_BASE_URL}/Report/DailyOccupancy2?${params.toString()}`,
      {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      },
    );

    const result = await response.json();
    return { status: response.status, ...result };
  } catch (e) {
    console.error("fetchDailyOccupancy error", e);
    return { status: 500, message: e.message };
  }
};
export const fetchAllReports = async ({ startDate, endDate }) => {
  try {
    const requestBody = {
      startDate: startDate,
      endDate: endDate,
    };

    const response = await fetch(
      `${process.env.REACT_APP_BASE_URL}/Report/getFiveReportsAsExcel?outletID=3`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestBody),
      },
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    // Get the response as a blob for file download
    const blob = await response.blob();

    // Create download link
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `All_Reports_${startDate}_to_${endDate}.xlsx`;
    document.body.appendChild(a);
    a.click();

    // Cleanup
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);

    return {
      status: response.status,
      success: true,
      message: "File downloaded successfully",
    };
  } catch (e) {
    console.error("fetchAllReports error", e);
    return { status: 500, success: false, message: e.message };
  }
};

export const creditItems = async ({ orderId, roomId, creditedAmount }) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/Booking/credit-items`,
      {
        orderId,
        roomId,
        creditedAmount,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error crediting items:", error);
    throw error;
  }
};

export const requestPasswordReset = async (email) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_BASE_URL}/Auth/request-password-reset`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }),
      },
    );

    // Check if response is OK
    if (!response.ok) {
      throw new Error(`Error: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Password reset request failed:", error);
    throw error;
  }
};

export const resetPassword = async (email, resetCode, newPassword) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_BASE_URL}/Auth/reset-password`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email,
          resetCode,
          newPassword,
        }),
      },
    );

    if (!response.ok) {
      throw new Error(`Error: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Password reset failed:", error);
    throw error;
  }
};

export const assignRoomType = async (assignments) => {
  console.log("🔥 assignRoomType function called with:", assignments);

  try {
    console.log("🔥 About to make fetch request...");
    const response = await fetch(
      `${process.env.REACT_APP_BASE_URL}/Booking/assign-roomtype`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(assignments), // Send the array directly
      },
    );

    console.log(
      "🔥 Fetch response received:",
      response.status,
      response.statusText,
    );

    if (!response.ok) {
      console.log("🔥 Response not ok, handling error...");
      try {
        const errorResult = await response.json();
        console.log("🔥 Error result:", errorResult);
        toast.error(
          errorResult.message || `Request failed: ${response.statusText}`,
        );
      } catch (parseError) {
        // If JSON parsing fails, fall back to statusText
        console.log("🔥 Error parsing JSON:", parseError);
        toast.error(`Request failed: ${response.statusText}`);
      }
      return null;
    }

    console.log("🔥 Response ok, parsing JSON...");
    const result = await response.json();
    console.log("🔥 Parsed result:", result);

    if (result.status === 200) {
      console.log("🔥 Success! Showing success toast...");
      toast.success(
        result.message ||
          `Successfully assigned ${assignments.length} room(s)!`,
      );
      return result.data || result; // Return result if data doesn't exist
    } else if (response.status === 200) {
      // Fallback: if HTTP status is 200 but result.status isn't 200
      console.log(
        "🔥 HTTP 200 but result.status not 200, treating as success...",
      );
      toast.success(`Successfully assigned ${assignments.length} room(s)!`);
      return result;
    } else {
      console.log("🔥 Result status not 200, showing error toast...");
      toast.error(`Failed to assign rooms: ${result.message}`);
      return null;
    }
  } catch (error) {
    console.log("🔥 Catch block - error occurred:", error);
    toast.error("Error assigning rooms.");
    console.error("Assign Rooms Error:", error);
    return null;
  }
};
